'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Render the view used to display a "no results" message.
 *
 * The no results view contains a simple message that conveys to the user the
 * fruitlessness of their request.
 *
 * @since 0.0.1
 * @class NoResultsView
 * @package React
 */
var NoResultsView = function (_Component) {
    _inherits(NoResultsView, _Component);

    /**
     * Component class constructor.
     *
     * Define the initial state of the preview modal. Essentially sets up the
     * `super` method and maintains a non-empty record for default state.
     *
     * @param object props The component properties
     * @param object context The component context
     */
    function NoResultsView(props, context) {
        _classCallCheck(this, NoResultsView);

        var _this = _possibleConstructorReturn(this, (NoResultsView.__proto__ || Object.getPrototypeOf(NoResultsView)).call(this, props, context));
        // We call `super` to define `this`


        _this.getDefaultStyles = function () {
            // Declare and initialize
            var theme = _this.context.theme || {};
            var palette = theme.palette || {};

            // Default container styles
            theme.noResultsViewContainer = _extends({
                position: 'absolute',
                top: '25%',
                left: '50%',
                display: 'block',
                textAlign: 'center',
                WebkitTransform: 'translate(-50%, -50%)',
                transform: 'translate(-50%, -50%)'
            }, theme.noResultsViewContainer);

            // Default icon styles
            theme.noResultsIcon = _extends({
                border: '8px solid',
                borderColor: palette.disabledColor,
                borderRadius: '50%',
                fontSize: 128,
                color: palette.disabledColor,
                width: 196,
                height: 196,
                padding: 24,
                opacity: .33
            }, theme.noResultsIcon);

            // Default loading styles
            theme.noResultsLoading = _extends({
                opacity: .33
            }, theme.noResultsLoading);

            // Default message styles
            theme.noResultsMessage = _extends({
                position: 'relative',
                fontSize: 20,
                color: palette.textColor,
                marginTop: -72,
                marginBottom: 16
            }, theme.noResultsMessage);

            // Throw back our modified theme
            return theme;
        };

        return _this;
    }

    /**
     * Retrieve the default styles for the print view.
     *
     * The print view is a standalone view that includes a control panel, a
     * print button, and the content body for the resource details that
     * were requested for printing.
     *
     * @since 0.0.2
     * @method getDefaultStyles
     * @return object Composite of prop styles and default styles
     */


    _createClass(NoResultsView, [{
        key: 'render',


        /**
         * Render the component content.
         *
         * The mandatory render method of the component. The no results view accepts
         * an icon, message, and optional action button.
         *
         * @since 0.0.1
         * @method render
         * @package React
         * @return string Markup representation of component content
         * @todo Define the `containerStyleRelative` in the theme base
         */
        value: function render() {
            // Declare and initialize
            var p = this.props;
            var s = this.state;
            var theme = this.getDefaultStyles();
            var icon = p.icon || 'inbox';
            var loading = p.loading;
            var message = p.message || 'No matching results were found.';
            var action = p.action;
            var relative = p.relative;
            var size = p.size || 128;

            // Define our container styles for (possible) override
            var containerStyle = _extends({}, theme.noResultsViewContainer);

            // If we want a static view, change our styles to reflect as such
            if (relative) {
                containerStyle.position = 'relative';
                containerStyle.top = 0;
                containerStyle.left = 0;
                containerStyle.marginBottom = p.marginBottom || 72;
                containerStyle.WebkitTransform = 'none';
                containerStyle.transform = 'none';
            }

            // Alter the icon size based on the provided size
            var iconStyle = _extends({}, theme.noResultsIcon, {
                fontSize: size,
                width: size + 68,
                height: size + 68
            });

            // Define the symbol component
            if (icon && !loading) {
                icon = _react2.default.createElement(
                    _FontIcon2.default,
                    { className: theme.icons, style: iconStyle },
                    icon
                );
            } else {
                // Define the loading styles
                var progressStyle = _extends({}, theme.noResultsLoading, p.progressStyle);

                // Define the progress color
                var progressColor = p.progressColor || '';

                icon = _react2.default.createElement(_CircularProgress2.default, { size: size, thickness: size / 16,
                    color: progressColor, style: progressStyle });
            }

            // Return our component
            return _react2.default.createElement(
                'div',
                { style: _extends({}, containerStyle, p.style), className: 'fade-in' },
                icon,
                _react2.default.createElement(
                    'div',
                    { style: theme.noResultsMessage },
                    message
                ),
                action,
                p.children
            );
        }
    }]);

    return NoResultsView;
}(_react.Component);

/**
 * Define our context values.
 *
 * Context values are passed down through the grapevine automatically. It saves
 * us from having to include parameters with every single iteration. Context
 * basically serves as a stand-in for global variables.
 *
 * @since 0.0.2
 * @type object
 */


NoResultsView.contextTypes = {
    p3: _propTypes2.default.object,
    theme: _propTypes2.default.object
};

// Pokeball GO!
exports.default = NoResultsView;


//////////////////
// WEBPACK FOOTER
// ./src/_components/NoResultsView.js
// module id = 281
// module chunks = 7